import DomainManager from '../../shared/utils/DomainManager';
import { getReturnUrl } from './getReturnUrl';

function removeTrailingSlash(url: string) {
  return url.replace(/\/$/, ''); // 정규표현식을 사용하여 마지막 슬래시 제거
}

export const getSigninWebLink = (targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);
  const authServiceDomain = domainManager.getAuthServiceDomain();

  const encodedReturnUrl =
    authServiceDomain !== removeTrailingSlash(window.location.origin) ? getReturnUrl() : '';

  return `${domainManager.getAuthServiceDomain()}/users/sign_in${
    encodedReturnUrl ? `?return_to=${encodedReturnUrl}` : ''
  }`;
};
